<template>
  <div class="tabs-container">
    <DxTabs :data-source="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
      :item-template="tabTemplate" orientation="horizontal" />
    <div v-if="selectedIndex === 0">
      <NomenclatoareCRM />
    </div>

    <!-- <div v-if="selectedIndex === 1">
      <NomenclatoareResurseUmane />
    </div> -->
  </div>
</template>
<script>
import { DxTabs } from 'devextreme-vue/tabs';
import NomenclatoareCRM from '../Comercial/CRM/NomenclatoareCRM.vue';
import NomenclatoareResurseUmane from '../ResurseUmane/NomenclatoareResurseUmane.vue';

export default {
  components: {
    NomenclatoareCRM,
    DxTabs,
    NomenclatoareResurseUmane,
  },
  data() {
    return {
      tabs: [
        { text: 'CRM' },
        // { text: 'Resurse Umane' }
      ],
      selectedIndex: 0,
    };
  },
  methods: {
    onTabChanged(e) {
      this.selectedIndex = e.component.option('selectedIndex');

      this.$router.replace({
        query: {
          ...this.$route.query,
          mainTab: this.selectedIndex
        }
      }).catch(() => { })
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return `<div>${itemData.text}</div>`;
    },
  },
  mounted() {
    if (this.$route.query.mainTab) {
      this.selectedIndex = Number(this.$route.query.mainTab)
    }
  }
};
</script>
<style scoped></style>
